import React from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import { Size } from '../../../../../Enums/Size.enum';
import { useTreatmentContext } from '../../../../../Services/TreatmentContext';
import TakeOver from './TakeOver';

interface Props {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  recordId: string;
  patientIdentifier: string;
}

const TakeOverModal: React.FC<Props> = props => {
  const { opened, onClose, onConfirm, recordId, patientIdentifier } = props;

  const { isCase } = useTreatmentContext();

  return (
    <Modal
      opened={opened}
      onClose={() => onClose()}
      fullScreen={false}
      size={Size.MD}
      wrapChat={isCase}>
      <Modal.Header title='nczi.examination.takeover.title' firstUpper />
      <Modal.Content>
        <TakeOver
          onClose={onClose}
          onConfirm={onConfirm}
          recordId={recordId}
          patientIdentifier={patientIdentifier}
        />
      </Modal.Content>
    </Modal>
  );
};

export default TakeOverModal;
